import {
  getCountries,
} from "libphonenumber-js";

interface CountrySelectProps {
  id: string;
  /** The saved two-letter code, if any; anything else starts unpicked. */
  value: string | undefined;
  onChange: (code: string) => void;
  errorId?: string | undefined;
}

const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

// Ascension and Tristan da Cunha have their own dialling codes but no passport.
const NOT_PASSPORT_COUNTRIES = new Set(["AC", "TA"]);

export const COUNTRY_OPTIONS = getCountries()
  .filter((code) => !NOT_PASSPORT_COUNTRIES.has(code))
  .map((code) => ({ code: code as string, label: regionNames.of(code) ?? code }))
  .sort((a, b) => a.label.localeCompare(b.label));

const KNOWN = new Set(COUNTRY_OPTIONS.map((c) => c.code));

/**
 * A country picked by name and submitted as its ISO alpha-2 code, which is
 * what flight suppliers take: a typed "USA" failed a booking after approval
 * (GET-20256).
 */
export function CountrySelect({
  id,
  value,
  onChange,
  errorId,
}: CountrySelectProps) {
  const selected = value && KNOWN.has(value.toUpperCase()) ? value.toUpperCase() : "";
  return (
    <select
      id={id}
      required
      aria-invalid={errorId ? true : undefined}
      aria-describedby={errorId}
      value={selected}
      onChange={(e) => onChange(e.target.value)}
      className={`block w-full rounded-md ${errorId ? "border-red-400" : "border-gray-300"} shadow-sm focus:outline-none focus:ring-2 focus:border-catch-red focus:ring-catch-red px-3 py-2 border`}
    >
      <option value="">Select a country</option>
      {COUNTRY_OPTIONS.map((c) => (
        <option key={c.code} value={c.code}>
          {c.label}
        </option>
      ))}
    </select>
  );
}
